import { Injectable } from '@angular/core';
import { ContactApiService } from './API/help/contact-api.service';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private contactApiService: ContactApiService, private translateService: TranslateService) { }

  public submitSupportForm(formData: FormData): Observable<any> {
    formData.append('lang', this.translateService.getCurrentLang() ?? environment.DEFAULT_CULTURE);
    return this.contactApiService.postFormData(formData);
  }
}
